import * as types from '../mutation-types';

// AS ABAS QUE O FANDATA ACRESCENTOU PRECISAM EXISTIR AQUI, e a falta delas travou a tela em
// 14/10: a aba "Com o Bira" ficou piscando "Carregando conversas" sem parar.
//
// O caminho da falha: a página de cada aba sai deste mapa. Para uma aba que não está no mapa a
// leitura é `undefined`, a tela soma 1 para pedir a próxima e `undefined + 1` é NaN. Com página
// NaN o servidor sempre devolve a primeira página, que nunca vem vazia, e "chegou ao fim" nunca
// é marcado: a lista pede mais, recebe o mesmo, e pede de novo.
//
// Por isso as três entram no estado inicial E na limpeza, e os dois leitores abaixo passam a ter
// resposta para aba desconhecida. Aba nova que esqueça este arquivo trava a tela, e trava
// girando, que é o pior jeito de falhar.
const ABAS_FANDATA = { spam: 0, pendencia: 0, bira: 0 };
const PAGINA_INICIAL = {
  me: 0,
  unassigned: 0,
  all: 0,
  appliedFilters: 0,
  ...ABAS_FANDATA,
};
const FIM_INICIAL = {
  me: false,
  unassigned: false,
  all: false,
  appliedFilters: false,
  spam: false,
  pendencia: false,
  bira: false,
};

const state = {
  currentPage: { ...PAGINA_INICIAL },
  hasEndReached: { ...FIM_INICIAL },
};

export const getters = {
  getHasEndReached: $state => filter => {
    return $state.hasEndReached[filter] ?? false;
  },
  getCurrentPageFilter: $state => filter => {
    return $state.currentPage[filter] ?? 0;
  },
  getCurrentPage: $state => {
    return $state.currentPage;
  },
};

export const actions = {
  setCurrentPage({ commit }, { filter, page }) {
    commit(types.default.SET_CURRENT_PAGE, { filter, page });
  },
  setEndReached({ commit }, { filter }) {
    commit(types.default.SET_CONVERSATION_END_REACHED, { filter });
  },
  reset({ commit }) {
    commit(types.default.CLEAR_CONVERSATION_PAGE);
  },
};

export const mutations = {
  [types.default.SET_CURRENT_PAGE]: ($state, { filter, page }) => {
    $state.currentPage = {
      ...$state.currentPage,
      [filter]: page,
    };
  },
  [types.default.SET_CONVERSATION_END_REACHED]: ($state, { filter }) => {
    if (filter === 'all') {
      $state.hasEndReached = {
        ...$state.hasEndReached,
        unassigned: true,
        me: true,
      };
    }
    $state.hasEndReached = {
      ...$state.hasEndReached,
      [filter]: true,
    };
  },
  [types.default.CLEAR_CONVERSATION_PAGE]: $state => {
    $state.currentPage = { ...PAGINA_INICIAL };
    $state.hasEndReached = { ...FIM_INICIAL };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
